import { useState, useEffect } from "react";
import CustomTip from "../../common/CustomToolTip/CustomTip";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import useApiServices from "../../utils/useApiServices";
import { GET_RULES_API } from "../../utils/constant";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import FrmAndRoutingRule from "./FrmAndRoutingRule";
import { Offcanvas } from "react-bootstrap";
import FRMShuffleRule from "./FRMSuffleRule";
import useHasPrivilege from "../../Privillages/useHasPrivilege";
import { ToolsActionRegistry } from "../../Privillages/ActionRegistry";

const FrmRoutingTable = ({ toggleRightBar }) => {
  const { TOOLS_OTHERS, FRM_ROUTING_EDIT } = ToolsActionRegistry;
  const hasFRMRoutingEdit = useHasPrivilege(TOOLS_OTHERS, FRM_ROUTING_EDIT);
  const { apiCallFnforGet } = useApiServices();
  const [merchants, setMerchants] = useState([]);
  const [show, setShow] = useState(false);
  const [showRule, setShowRule] = useState(false);
  const [mid, setMid] = useState("");
  const [viewOnly, setViewOnly] = useState(false);
  const getAllMerchantsWithTheirRules = async () => {
    try {
      const response = await apiCallFnforGet(GET_RULES_API);
      if (response.statusCode == 200) {
        const finalRes = response.data.map((item) => ({
          id: item.mid,
          companyName: item.companyName,
          action: (
            <button className="badge bg-primary text-white ms-2">View</button>
          ),
        }));
        setMerchants(finalRes);
      } else if (response?.statusCode === 304) {
        setMerchants([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const addRule = () => {
    // setFlag(true);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    getAllMerchantsWithTheirRules();
  }, [show]);

  const columns = [
    {
      headerName: "Merchant Id",
      field: "id",
      minWidth: 300,
    },
    {
      headerName: "Company Name",
      field: "companyName",
      minWidth: 300,
    },
    {
      headerName: "Action",
      filed: "action",
      minWidth: 300,
      renderCell: (params) => {
        const onClick = () => {
          console.log(params?.row?.id);
          setMid(params?.row?.id);
          setShowRule(true);
          setViewOnly(false);
        };
        const onClickView = () => {
          console.log(params?.row?.id);
          setMid(params?.row?.id);
          setShowRule(true);
          setViewOnly(true);
        };
        return (
          <div className="d-flex justify-content-start align-items-center mt-3 gap-3">
            <button className="badge badge-info" onClick={onClickView}>
              View
            </button>
            {hasFRMRoutingEdit && (
              <button className="badge badge-primary" onClick={onClick}>
                Edit
              </button>
            )}
          </div>
        );
      },
    },
  ];

  const offcanvasStyle = {
    width: "90vw", // Set width to 70vw
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer className="d-flex justify-content-end">
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between bg-white">
        <div className="d-flex justify-content-start align-items-center">
          <button
            type="button"
            className="btn-close m-3"
            onClick={toggleRightBar}
          ></button>
          <div className="fs-2 text-dark fw-bold">FRM And Routing Rule</div>
        </div>
        {hasFRMRoutingEdit && (
          <div className="d-flex gap-2 justify-content-end mt-3 me-4 mb-2">
            <CustomTip size="18" placement="top" title="Add Rules">
              <div className="" onClick={addRule}>
                <AddCircleOutlineIcon fontSize="large" />
              </div>
            </CustomTip>
          </div>
        )}
      </div>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        style={offcanvasStyle}
        backdrop="static"
        keyboard={false}
      >
        <div className="d-flex justify-content-start align-items-center">
          <Offcanvas.Header
            closeButton
            onClick={() => setShow(false)}
          ></Offcanvas.Header>
          <h5
            class="offcanvas-title  fs-2 text-dark fw-bold"
            id="offcanvasLabel"
          >
            Add Rule
          </h5>
        </div>
        <Offcanvas.Body>
          <FrmAndRoutingRule
            getAllMerchantsWithTheirRules={getAllMerchantsWithTheirRules}
            handleClose={handleClose}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="col-12">
              <div className="card-body">
                <div>
                  <DataGrid
                    columns={columns}
                    rows={merchants}
                    slots={{
                      toolbar: CustomToolbar,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FRMShuffleRule
        mid={mid}
        getAllMerchantsWithTheirRules={getAllMerchantsWithTheirRules}
        showRule={showRule}
        setShowRule={setShowRule}
        viewOnly={viewOnly}
        type={"Frm"}
        isPayout={false}
      />
    </div>
  );
};

export default FrmRoutingTable;
